module.exports = {
  "id": "leaf",
  "title": "leaf",
  "image": "provision/parts/leaf/leaf.png",
  "info": [
    {
      "text": "Add a leaf to your project",
      "image": "provision/parts/leaf/leaf.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/leaf/leaf.png"
} ;